var _defs, _rect, _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g4, _g5, _path12, _path13, _path14, _path15, _g6, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecondContent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 131,
    height: 198,
    viewBox: "0 0 131 198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 131,
    height: 198,
    transform: "translate(0 567)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 107.921,
    height: 183.491,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 27.838,
    height: 126.647,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 84.399,
    height: 77.116,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 22.44,
    height: 22.44,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 23.151,
    height: 23.151,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 18.615,
    height: 18.614,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 23.831,
    height: 23.831,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 107.919,
    height: 134.35,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_23",
    "data-name": "Mask Group 23",
    transform: "translate(0 -567)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(40.608 553.462) rotate(21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 49.649,
    height: 7.35,
    transform: "translate(71.178 48.994) rotate(-80.682)",
    fill: "#39b54a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    clipPath: "url(#clip-path-2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M109.977,127.684,91.106,259.807a2.241,2.241,0,0,1-2.227,1.978H27.965a2.241,2.241,0,0,1-2.227-1.978L6.867,127.684Z",
    transform: "translate(-4.211 -78.295)",
    fill: "#492001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(50.593 48.994)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 127.135,
    height: 7.35,
    transform: "translate(0.002 125.458) rotate(-80.683)",
    fill: "#83c78d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(12.528 34.914)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(1.188)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M54.1,110.587l-11.118,2.039a4.655,4.655,0,0,1-5.4-3.728L35.535,97.781a4.656,4.656,0,0,1,3.728-5.4l11.118-2.039a4.656,4.656,0,0,1,5.4,3.728l2.039,11.118a4.655,4.655,0,0,1-3.728,5.4",
    transform: "translate(-35.459 -90.263)",
    fill: "#976e47"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(17.848 5.143)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M92.973,126.576l-10.551-2.494A5.068,5.068,0,0,1,78.666,118l2.494-10.551a5.068,5.068,0,0,1,6.08-3.755l10.552,2.494a5.068,5.068,0,0,1,3.755,6.08l-2.494,10.552a5.068,5.068,0,0,1-6.08,3.755",
    transform: "translate(-78.531 -103.56)",
    fill: "#976e47"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M78.012,179.874l-8.35-1.974a4.655,4.655,0,0,1-3.45-5.585l1.974-8.35a4.655,4.655,0,0,1,5.585-3.45l8.35,1.974a4.655,4.655,0,0,1,3.45,5.585l-1.974,8.35a4.655,4.655,0,0,1-5.585,3.45",
    transform: "translate(-53.053 -133.265)",
    fill: "#976e47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M197.012,256.874l-8.35-1.973a4.656,4.656,0,0,1-3.45-5.585l1.974-8.35a4.655,4.655,0,0,1,5.585-3.45l8.35,1.974a4.655,4.655,0,0,1,3.45,5.585l-1.974,8.35a4.655,4.655,0,0,1-5.585,3.45",
    transform: "translate(-126.022 -180.481)",
    fill: "#976e47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M43.915,215.012l-4.865,1.353a4.2,4.2,0,0,1-5.157-2.913l-1.353-4.865a4.2,4.2,0,0,1,2.913-5.157l4.865-1.353a4.2,4.2,0,0,1,5.157,2.913l1.353,4.865a4.2,4.2,0,0,1-2.913,5.157",
    transform: "translate(-32.388 -158.733)",
    fill: "#976e47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M34.124,162.159,32.9,156.912a3.493,3.493,0,0,1,2.6-4.183l5.248-1.224a3.493,3.493,0,0,1,4.183,2.6l1.224,5.248a3.493,3.493,0,0,1-2.6,4.183l-5.248,1.224a3.494,3.494,0,0,1-4.183-2.6",
    transform: "translate(-32.646 -127.76)",
    fill: "#976e47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M112.053,219.291l-.477-6.972a4.531,4.531,0,0,1,4.2-4.815l6.972-.477a4.531,4.531,0,0,1,4.815,4.2l.476,6.972a4.53,4.53,0,0,1-4.2,4.815l-6.972.476a4.53,4.53,0,0,1-4.815-4.2",
    transform: "translate(-80.939 -161.856)",
    fill: "#976e47"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M43.053,259.291l-.477-6.972a4.53,4.53,0,0,1,4.2-4.815l6.972-.477a4.53,4.53,0,0,1,4.815,4.2l.477,6.972a4.531,4.531,0,0,1-4.2,4.815l-6.972.476a4.53,4.53,0,0,1-4.815-4.2",
    transform: "translate(-38.629 -186.384)",
    fill: "#976e47"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M78.576,226.3l-2.872-4.29a3.347,3.347,0,0,1,.917-4.629l4.29-2.872a3.347,3.347,0,0,1,4.629.917l2.872,4.29a3.347,3.347,0,0,1-.917,4.629l-4.29,2.872a3.347,3.347,0,0,1-4.629-.917",
    transform: "translate(-58.606 -166.104)",
    fill: "#976e47"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M206.124,210.159l-1.224-5.248a3.493,3.493,0,0,1,2.6-4.183l5.248-1.224a3.493,3.493,0,0,1,4.183,2.6l1.224,5.248a3.493,3.493,0,0,1-2.6,4.183l-5.248,1.224a3.494,3.494,0,0,1-4.183-2.6",
    transform: "translate(-138.115 -157.193)",
    fill: "#976e47"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M162.5,207.569l-1.265-5.425a4.655,4.655,0,0,1,3.466-5.575l5.425-1.265a4.655,4.655,0,0,1,5.575,3.466l1.265,5.425a4.655,4.655,0,0,1-3.466,5.574l-5.425,1.266a4.655,4.655,0,0,1-5.575-3.466",
    transform: "translate(-111.321 -154.599)",
    fill: "#976e47"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M132.663,172.863l-6.345-3.663a4.655,4.655,0,0,1-1.7-6.341l4.1-7.093a4.655,4.655,0,0,1,6.341-1.7l6.345,3.663a4.655,4.655,0,0,1,1.7,6.341l-4.1,7.093a4.655,4.655,0,0,1-6.341,1.7",
    transform: "translate(-88.565 -129.008)",
    fill: "#976e47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(65.785 0.697)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M216.749,110.073l-8.734.6a4.655,4.655,0,0,1-4.947-4.314l-.6-8.734a4.655,4.655,0,0,1,4.314-4.947l8.735-.6a4.655,4.655,0,0,1,4.947,4.314l.6,8.734a4.655,4.655,0,0,1-4.314,4.947",
    transform: "translate(-202.46 -92.066)",
    fill: "#976e47"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(40.826 0.306)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M159.181,109.6l-9.741,4.812a4.656,4.656,0,0,1-6.218-2.106l-4.812-9.741a4.656,4.656,0,0,1,2.106-6.218l9.741-4.812a4.656,4.656,0,0,1,6.218,2.106l4.812,9.741a4.656,4.656,0,0,1-2.106,6.218",
    transform: "translate(-137.933 -91.053)",
    fill: "#976e47"
  }))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M194.908,162.353l-11.088-2.621a3.936,3.936,0,0,1-2.917-4.723l2.621-11.088a3.936,3.936,0,0,1,4.723-2.917l11.088,2.621a3.936,3.936,0,0,1,2.917,4.723l-2.621,11.087a3.937,3.937,0,0,1-4.723,2.917",
    transform: "translate(-123.392 -121.313)",
    fill: "#976e47"
  }))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M105.963,131.165,87.8,258.3H29.041L10.881,131.165Zm4.014-3.481H6.867L25.739,259.807a2.241,2.241,0,0,0,2.227,1.978H88.879a2.241,2.241,0,0,0,2.226-1.978Z",
    transform: "translate(-4.211 -78.295)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M106.182,126.519H1.744a1.741,1.741,0,1,1,0-3.481H106.182a1.741,1.741,0,0,1,0,3.481",
    transform: "translate(-0.002 -75.446)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M125.6,256.422a24.384,24.384,0,1,1-24.384-24.384A24.384,24.384,0,0,1,125.6,256.422",
    transform: "translate(-47.11 -142.284)",
    fill: "#00653b"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(0 49.139)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M107.919,127.231a1.743,1.743,0,0,1-1.741,1.741h-.654L86.9,259.411a2.242,2.242,0,0,1-2.228,1.977H38.53L87.678,142.124l-83.86-6.707L2.9,128.972H1.741A1.741,1.741,0,0,1,0,127.231a1.574,1.574,0,0,1,.012-.193h107.9a1.576,1.576,0,0,1,.012.193",
    transform: "translate(0 -127.038)"
  }))))))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    d: "M-25.681,883.923,37.45,861.97c4.968-1.728,10.595,1.442,12.8,7.11,2.252,5.781.251,12.336-4.715,14.63L-18.3,913.193c-8.817,4.073-18.011.286-19.966-8.469C-40.164,896.212-34.294,886.918-25.681,883.923Z",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 52.619, -228.191)",
    fill: "#db8e6c"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5_copy_2",
    "data-name": "Rectangle 5 copy 2",
    d: "M-13.036,1043.24l63.13-21.953c4.968-1.728,10.595,1.442,12.8,7.11,2.252,5.781.251,12.336-4.715,14.629L-5.653,1072.51c-8.817,4.073-18.011.286-19.966-8.469C-27.52,1055.529-21.65,1046.235-13.036,1043.24Z",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 51.842, -310.981)",
    fill: "#db8e6c"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5_copy",
    "data-name": "Rectangle 5 copy",
    d: "M-25.383,973.133l63.13-21.953c4.968-1.728,10.595,1.442,12.8,7.11,2.252,5.781.251,12.336-4.715,14.629L-18,1002.4c-8.817,4.073-18.011.286-19.966-8.469C-39.866,985.422-34,976.128-25.383,973.133Z",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 55.689, -274.305)",
    fill: "#db8e6c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondContent);
export default __webpack_public_path__ + "static/media/second-content.82f89de5a04b9a933a40637586f8ec49.svg";
export { ForwardRef as ReactComponent };